export default Object.freeze({
    STATUS_AWAITING_PAYMENT: '1',
    STATUS_AWAITING_INVOICE: '2',
    STATUS_AWAITING_RELEASE: '3',
    STATUS_INVOICED: '4',
    STATUS_CANCELED: '5',
    STATUS_VOIDED: '6',
    STATUS_DENIED: '7',
    STATUS_AWAITING_AUTHORITY_RESPONSE: '8',
    STATUS_AWAITING_FISCAL_ADJUSTMENT: '9',
});